import { NgModule } from '@angular/core';
import { IonicModule } from"@ionic/angular";
import { TableNumeroPipe } from './table-numero.pipe';
@NgModule({
    declarations: [
        TableNumeroPipe
    ],
    imports: [
        IonicModule
    ],
    exports: [
        TableNumeroPipe
    ]
})
export class TableNumeroPipeModule {}